import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const SubscriptionDetailsGuard: CanActivateFn = (route): boolean => {
	const router = inject(Router);
	const state = router.currentNavigation()?.extras?.state;
	if (!state) {
		const commands = route.parent?.url?.map(({ path }) => path) ?? [];
		router.navigate(commands).then();
		return false;
	}
	return true;
};
